export const exposedJSMethods = [
  'addField',
  'autoResizeSVG',
  'reRenderDropdownMenu',
  'getCurrentFields',
  'addMenu',
  'getValue',
  'putValue',
  'isWorkspaceConfigLoaded',
  'loadWorkspaceConfig',
  'isConfigLoaded',
  'loadConfig',
  'putWorkspaceValue',
  'getWorkspaceValue',
  'getContainerElement',
  'getComponents',
  'getContext',
  'isMultipleWorkspaces',
  'initializeZoom',
  'getD3LinksAndComponents',
  'getD3LinksByComponent',
  'getD3LinksAsTree',
  'isActive',
  'isVisible',
  'getReferences',
  'getTags',
  'getModel',
  'getD3SVG',
  'getWidth',
  'getHeight',
  'addCSS',
];
